import Block from '@/components/Block'
import { useBooking } from '@/context/booking'
import { CalendarUrl, createCalendarUrl } from '@/lib/calendarUrl'
import { makeBooking } from '@/lib/makeBooking'
import { SessionCard } from '@/shared/api-generated-types'
import AddToCalendar from '@/widgets/AddToCalendar'
import BookingSuccess from '@/widgets/BookingSuccess'
import ClassDetailsCta from '@/widgets/ClassDetailsCta'
import Modal from '@/widgets/Modal'
import React from 'react'
import * as styles from './style'

export interface Props {
  classId?: string
  session: Array<SessionCard>
  noCancel?: boolean
  multipleSession?: boolean
  onClickCancel?: () => void
  onClickViewAll?: () => void
}

const ClassCtaBlock = ({
  classId,
  session,
  noCancel,
  multipleSession,
  onClickCancel,
  onClickViewAll,
}: Props): JSX.Element => {
  const { state: bookingState, dispatch: bookingDispatch } = useBooking()
  const [bookingSuccess, setBookingSuccess] = React.useState<boolean>(false)
  const [openAddtoCalendar, setOpenAddtoCalendar] = React.useState<boolean>(false)
  const [calendarUrl, setCalendarUrl] = React.useState<CalendarUrl>({
    googleCalendarUrl: '',
    yahooCalendarUrl: '',
    outlookCalendarUrl: '',
    iCalUrl: '',
  })

  const handleBookingAction = (session: Partial<SessionCard>): void => {
    const { sessionId } = session
    bookingDispatch({ type: 'FETCHING', payload: { sessionId } })
    makeBooking({ classId, sessionId }).then((response) => {
      if (response) {
        bookingDispatch({ type: 'BOOKED', payload: { sessionId } })
        setCalendarUrl(createCalendarUrl(session))
        toogleBookingSuccess()
      } else bookingDispatch({ type: 'FAILED', payload: { sessionId } })
    })
  }
  const toogleBookingSuccess = (): void => {
    setBookingSuccess(!bookingSuccess)
  }
  return (
    <>
      {bookingSuccess ? (
        <Modal onDismiss={toogleBookingSuccess}>
          {openAddtoCalendar ? (
            <AddToCalendar
              onDismiss={() => setOpenAddtoCalendar(false)}
              googleCalendarUrl={calendarUrl.googleCalendarUrl}
              yahooCalendarUrl={calendarUrl.yahooCalendarUrl}
              outlookCalendarUrl={calendarUrl.outlookCalendarUrl}
              iCalUrl={calendarUrl.iCalUrl}
            />
          ) : (
            <BookingSuccess onClickAddToCalendar={() => setOpenAddtoCalendar(true)} />
          )}
        </Modal>
      ) : null}
      <Block theme="tertiary" phantomTether className={`${styles.root} hide-gte-tablet p-0-lte-desktop`}>
        <ClassDetailsCta
          session={session[0]}
          bookingState={bookingState}
          noCancel={noCancel}
          multipleSession={multipleSession}
          handleBookingAction={handleBookingAction}
          onClickCancel={onClickCancel}
          onClickViewAll={onClickViewAll}
        />
      </Block>
    </>
  )
}
export default ClassCtaBlock
